module.exports = __webpack_public_path__ + "img/ico-unread.c778fd49.svg";